import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

type UseAddressByPostcodeProps = {
  postcode: string | undefined
  options: {
    enabled: boolean
  }
}

export type AddressType = {
  formatted_address: string[]
  thoroughfare: string
  building_name: string
  sub_building_name: string
  sub_building_number: string
  building_number: string
  line_1: string
  line_2: string
  line_3: string
  line_4: string
  locality: string
  town_or_city: string
  county: string
  district: string
  country: string
}

const GET_ADDRESS_URL = `/api/services/get-address`

const getAddress = (postcode: string) =>
  getJSON({ url: `${GET_ADDRESS_URL}/${postcode}` })

const useAddressByPostcode = ({
  postcode,
  options,
}: UseAddressByPostcodeProps) => {
  const { data, isLoading } = useQuery<{
    result: { addresses: AddressType[] }
  }>(['postcode', postcode], () => getAddress(postcode as string), {
    enabled: postcode !== '' && postcode !== undefined && options.enabled,
  })

  return {
    data: data?.result?.addresses,
    isLoading,
  }
}

export default useAddressByPostcode
